<div class="p-3">
    <h1 mat-dialog-title>Invite Member</h1>
    <div [formGroup]="formControl">
        <div class="row justify-content-between mt-4">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker> 
                    <mat-label>First Name <span class="required-input">*</span></mat-label>
                    <input matInput placeholder="Enter first name"
                        formControlName="firstName" [errorStateMatcher]="matcher" required>
                </mat-form-field>
                <app-form-field-error [control]="formControl.controls['firstName']"></app-form-field-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Last Name <span class="required-input">*</span></mat-label>
                    <input matInput placeholder="Enter last name" formControlName="lastName"
                        [errorStateMatcher]="matcher" required>
                </mat-form-field>
                <app-form-field-error [control]="formControl.controls['lastName']"></app-form-field-error>
            </div>
        </div>
        <div class="row justify-content-between mt-4">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Email Address <span class="required-input">*</span></mat-label>
                    <input matInput placeholder="Enter email address"
                        formControlName="emailAddress" [errorStateMatcher]="matcher" required>
                </mat-form-field>
                <app-form-field-error [control]="formControl.controls['emailAddress']"></app-form-field-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matInput placeholder="Enter phone number" formControlName="phoneNumber" (input)="onPhoneNumberChanged($event)">
                    <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                    <mat-error *ngIf="formControl.controls['phoneNumber'].invalid">
                        Required format | (XXX) XXX-XXXX
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row justify-content-between mt-4">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Member Role <span class="required-input">*</span></mat-label>
                    <mat-select formControlName="role" [errorStateMatcher]="matcher" required>
                        <mat-option value="2">Organization Administrator</mat-option>
                        <mat-option value="3">Organization Member</mat-option>
                    </mat-select>
                </mat-form-field>
                <app-form-field-error [control]="formControl.controls['role']"></app-form-field-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column"></div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-end text-muted">
        <span class="required-input">*</span>&nbsp;- Required fields
    </div>
    <div class="row mt-4">
        <mat-checkbox [checked]="data.activationLink" (change)="onActivationLinkToggle($event)">
            Send email with activation link for activating account
        </mat-checkbox>
    </div>
    <div *ngIf="!data.activationLink" [formGroup]="passwordFormControl">
        <div class="row mt-4">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Password <span class="required-input">*</span></mat-label>
                    <input matInput type="password" placeholder="Enter first name"
                        formControlName="password" [errorStateMatcher]="matcher" required>
                </mat-form-field>
                <app-form-field-error [control]="passwordFormControl.controls['password']"></app-form-field-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Confirm Password <span class="required-input">*</span></mat-label>
                    <input matInput type="password" placeholder="Confirm password"
                        formControlName="confirmPassword" [errorStateMatcher]="matcher" required>
                </mat-form-field>
                <app-form-field-error [control]="passwordFormControl.controls['confirmPassword']"></app-form-field-error>
            </div>
        </div>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCloseClick()">
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="onSaveClick()" [disabled]="!isSaveEnabled()">
            {{ data.activationLink ? 'Send Invitation' : 'Add Member' }}
        </button>
    </div>
</div>